import React, { useState } from 'react';
import { Dropdown } from 'react-bootstrap-5';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import UnstyledDropdownToggle from 'components/bootstrap_extensions/bs5/unstyled_dropdown_toggle';
import {
  faEdit,
  faEllipsisVertical,
  faFileExport,
  faLock,
  faMailbox,
  faTrash
} from '@fortawesome/pro-solid-svg-icons';
import CallListExportModal from '../call_lists/export/modal';
import ExportUnavailable from '../call_lists/export/export_unavailable';
import type { DataExportTemplate } from 'bundles/connect/types';
import CallListDeleteModal from './call_list_delete_modal';
import { mailersTemplatesUrl } from 'bundles/connect/helpers/prospect_api';

type Props = {
  callListId: number;
  callListName: string;
  exportDisabled?: string;
  pathForCallList: string;
  templates: DataExportTemplate[];
}


export default function CallListActionDropdown({
  callListId,
  callListName,
  exportDisabled,
  pathForCallList,
  templates
}: Props) {

  const [showExportModal, setShowExportModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  return (
    <>
      <Dropdown drop="start">
        <Dropdown.Toggle as={UnstyledDropdownToggle}>
          <span className="d-flex align-items-center justify-content-center p-2 clickable">
            <FontAwesomeIcon icon={faEllipsisVertical} />
          </span>
        </Dropdown.Toggle>
        <Dropdown.Menu className="py-0" renderOnMount>
          {exportDisabled ? (
            <ExportUnavailable disabled={exportDisabled}>
              <div>
                <Dropdown.Item disabled>
                  <FontAwesomeIcon className="me-2" fixedWidth icon={faLock} />
                  Export List
                </Dropdown.Item>
              </div>
            </ExportUnavailable>
          ) :
            (
              <Dropdown.Item onClick={() => setShowExportModal(true)}>
                <FontAwesomeIcon className="me-2" fixedWidth icon={faFileExport} />
                Export List
              </Dropdown.Item>
            )}
          <Dropdown.Item data-turbo={false} href={pathForCallList}>
            <FontAwesomeIcon className="me-2" fixedWidth icon={faEdit} />
            Edit List
          </Dropdown.Item>
          <Dropdown.Item data-turbo={false} href={mailersTemplatesUrl(callListId)}>
            <FontAwesomeIcon className="me-2" fixedWidth icon={faMailbox} />
            Create Mailers
          </Dropdown.Item>
          <Dropdown.Item className="text-danger" onClick={() => setShowDeleteModal(true)}>
            <FontAwesomeIcon className="me-2" fixedWidth icon={faTrash} />
            Delete List
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
      <CallListExportModal
        callListId={callListId}
        show={showExportModal}
        templates={templates}
        onHide={() => setShowExportModal(false)}
      />
      <CallListDeleteModal
        callListName={callListName}
        pathForCallList={pathForCallList}
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
      />
    </>
  );
}
